module.exports = __webpack_public_path__ + "img/bicc_xmas_2022.2818b529.png";